module.exports = __webpack_public_path__ + "img/konfortify-card-basic.c9b19c6b.png";